import * as React from "react";
import FontAwesomeIcon from "@fortawesome/react-fontawesome";
import { faUser, faBuilding } from "@fortawesome/fontawesome-pro-light";
import { observer, inject } from "mobx-react";
import { PresenceStore, PresenceState } from "../../lib/index";
import styles from "./Avatar.scss";
import * as _ from "lodash";


export interface IAvatarProps {
	/**
	 * pass here the url for the avatar picture. When you pass a empty string, an default icon will be used
	 */
	url: string;
	/**
	 * size -> Width, Height in px
	 */
	size?: number;
	/**
	 * The dscaid is used for displaying the online status. Don't pass it, if you don't need to
	 */
	dscaid?: number;
	/**
	 * When set, the default icon will be faBuilding instead of faAvatar
	 */
	isCompany?: boolean;
}

export function Avatar(props: IAvatarProps) {
	const size = props.size || 30;
	const isCompany = props.isCompany || false;
	const icon = isCompany ? faBuilding : faUser;

	return (
		<div
			className={styles.avatar}
			style={{
				width: `${size}px`,
				height: `${size}px`,
				backgroundImage: props.url ? `url(${props.url})` : "none",
			}}
		>
			{props.url ?
				<img src={props.url} style={{ width: "100%", height: "100%", opacity: 0 }}/>
			:
				<FontAwesomeIcon
					icon={icon}
					style={{
						display: "block",
						margin: "20% auto",
						width: "60%",
						height: "60%",
					}}
				/>
			}
			<OnlineStatus size={size * 0.25} dscaid={props.dscaid} className={styles.avatarOnlineStatus}/>
		</div>
	);
}

interface IOnlineStatusProps{
	size?: number;
	dscaid?: number;

	style?: React.CSSProperties;
	className?: string;

	presenceStore?: PresenceStore;
}

@inject("presenceStore")
@observer
export class OnlineStatus extends React.Component<IOnlineStatusProps, any> {
	constructor(props) {
		super(props);
	}

	public render() {
		const size = this.props.size || 10;
		let presence = PresenceState.OFFLINE;

		if (this.props.dscaid && this.props.presenceStore.userPresence.has(this.props.dscaid)) {
			presence = this.props.presenceStore.userPresence.get(this.props.dscaid).presence;
		}

		switch (presence) {
			case PresenceState.CONNECTION_PROBLEM:
				return(
					<FontAwesomeIcon icon="bolt"
						style={this.props.style}
						className={`${this.props.className || ""} ${styles.onlineStatus} ${styles.connectionProblem}`}
					/>
				);
			case PresenceState.ONLINE:
				return (
					<div
						style={_.assign({ width: size, height: size }, this.props.style)}
						className={`${this.props.className || ""} ${styles.onlineStatus} ${styles.online}`}
					/>
				);
			/*
			case PresenceState.OFFLINE:
				return (
					<div
						className = {`${styles.onlineStatus} ${styles.offline}`}
						style={{
							width: this.props.size * 0.25,
							height: this.props.size * 0.25,
					}}/>
				);
			*/
			default:
				return <div/>;
		}
	}
}



// WEBPACK FOOTER //
// ./src/common/Avatar/Avatar.tsx